/** @jsxRuntime classic */
/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
const React = require('react');
const { Helmet } = require('react-helmet-async');
const { getPublicPageSeo } = require('../site/publicPageSeo');
const { structuredDataForRoute } = require('../site/structuredData');

function SiteRouteHelmet({ path, jsonLd, canonical, robots }) {
  const route = getPublicPageSeo(path);
  if (!route) return null;
  const seo = Object.assign({}, route, {
    canonical: canonical || route.canonical,
    robots: robots || route.robots,
  });
  const structuredData = jsonLd || structuredDataForRoute(seo);

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={seo.canonical} />
      <meta name="robots" content={seo.robots} />
      <meta property="og:type" content={seo.pageType === 'article' ? 'article' : 'website'} />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      {structuredData.map((item, index) => (
        <script type="application/ld+json" key={`site-route-jsonld-${index}`}>
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

module.exports = SiteRouteHelmet;
